import { render, staticRenderFns } from "./CartLoader.vue?vue&type=template&id=2954cfe4&"
import script from "./CartLoader.vue?vue&type=script&lang=js&"
export * from "./CartLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports